import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createErrorReport',
    serviceName: 'auth',
    query: gql`
      mutation createErrorReport(
        $product_shop_id: String
        $shop_id: String
        $product_id: String
        $location: String # موقعیت خطا - url
        $product_name: String # نام صحیح محصول
        $product_brand: String # برند صحیح محصول
        $product_details: String # جزئیات صحیح محصول
        $product_category: String # دسته‌بندی صحیح محصول
        $product_image: String # عکس محصول اشتباه است
        $product_image_quality: String # کیفیت عکس محصول پایین است
        $product_unit: String # واحد صحیح محصول
        $product_booth: String # غرفه صحیح محصول
        $max_number_buy: String # حداکثر تعداد خرید
        $min_number_buy: String # حداقل تعداد خرید
        $description: String
      ) {
        createErrorReport(
          product_shop_id: $product_shop_id
          shop_id: $shop_id
          product_id: $product_id
          location: $location
          product_name: $product_name
          product_brand: $product_brand
          product_details: $product_details
          product_category: $product_category
          product_image: $product_image
          product_image_quality: $product_image_quality
          product_unit: $product_unit
          product_booth: $product_booth
          max_number_buy: $max_number_buy
          min_number_buy: $min_number_buy
          description: $description
        ) {
          model {
            id
          }
          messages
        }
      }
    `,
  },
};

export default schema;
